import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const validateAddressAsync = createAsync(body => {
  return async function validateAddress(options) {
    const resp = await api.Address.validateAddress(body, options);
    return resp;
  };
});
const addNewAddressAsync = createAsync(body => {
  return async function addNewAddress(options) {
    const resp = await api.Address.addNewAddress(body, options);
    return resp;
  };
});
const updateAddressAsync = createAsync(body => {
  return async function updateAddress(options) {
    const resp = await api.Address.updateAddress(body, options);
    return resp;
  };
});
const batchGetAddressesAsync = createAsync(body => {
  return async function batchGetAddresses(options) {
    const resp = await api.Address.batchGetAddresses(body, options);
    return resp;
  };
});
const parseSingleLineAddressAsync = createAsync(body => {
  return async function parseSingleLineAddress(options) {
    const resp = await api.Address.parseSingleLineAddress(body, options);
    return resp;
  };
});
const AddressStore = types.model('AddressStore', {
  validateAddressAsync,
  addNewAddressAsync,
  updateAddressAsync,
  batchGetAddressesAsync,
  parseSingleLineAddressAsync
});
export const address = types.optional(AddressStore, {});